module.exports = __webpack_public_path__ + "img/wineexpress.e8752aba.jpg";